'use client';

import { useState } from 'react';
import Link from 'next/link';
import { GTM_EVENT } from '@/shared/constants/gtm';
import { gtmClick } from '@/shared/utils/gtm';

import { getEventStatus, type HubEvent } from '../data';
import { getHubImages, HUB_IMAGE_FALLBACK, resolveHubEventImageSrc } from '../_lib/hubEventImage';
import { SUB_LABEL } from '../_lib/tabs';
import s from '../page.module.scss';
import { HubEventPeriodText } from './HubEventPeriodText';
import { HubEventStatusBadges } from './HubEventStatusBadges';

interface HubEventCardProps {
  event: HubEvent;
}

export function HubEventCard({ event }: HubEventCardProps) {
  const status = getEventStatus(event);
  const images = getHubImages(event.imageKey);
  const [src, setSrc] = useState(resolveHubEventImageSrc(images.card));

  return (
    <li className={s.card}>
      <Link
        href={event.href}
        target={event.target}
        rel={event.target === '_blank' ? 'noopener noreferrer' : undefined}
        className={s.card_link}
        {...gtmClick(GTM_EVENT.BTN, event.cardTitle!, event.href)}
      >
        <div className={s.card_thumb}>
          <img
            src={src}
            alt=""
            loading="lazy"
            onError={() => setSrc(HUB_IMAGE_FALLBACK.card)}
          />

          {status && (
            <div className={s.card_status_wrap}>
              <HubEventStatusBadges
                status={status}
                subLabel={SUB_LABEL[event.category]}
                size="small"
              />
            </div>
          )}
        </div>
        <div className={s.card_body}>
          <h3 className={s.card_title}>{event.cardTitle}</h3>
          <div className={s.card_meta}>
            <HubEventPeriodText status={status} className={s.card_period} />
            {event.memo && <span className={s.card_memo}>{event.memo}</span>}
          </div>
        </div>
      </Link>
    </li>
  );
}
